import axiosService from '../utils/axios';

const createOneTimePayment = async () => {
    const { data } = await axiosService.get(
        '/payment/create/one'
    );
    return data;
};

const createSubscriptionPayment = async () => {
    const { data } = await axiosService.get(
        '/payment/create/subscription'
    );
    return data;
};

const issueBoost = async (sessionId: string) => {
    const { data } = await axiosService.post(
        '/payment/issue-boost',
        { sessionId }
    );
    return data;
};

export { createOneTimePayment, createSubscriptionPayment, issueBoost };
